import {loadSalesforceStores} from "./salesforceStoresCache";
import {loadRetailerMap} from "./retailerMapCache";
import {loadNextPeriod} from "./nextPeriodCache";
import React, {useState} from "react";
import iconHardReload from "../../assets/hard-reload.svg";
import {faIcons} from "../iconConstants";

export const BreakCacheButton = () => {
    const [loading, setLoading] = useState(false);

    const breakCache = () => {
        setLoading(true);
        Promise.all([
            loadSalesforceStores(true),
            loadRetailerMap(true),
            loadNextPeriod(true)
        ]).then(() => {
            console.log('cache cleared');
            window.location.reload();
        }).finally(() => setLoading(false));
    }

    return (<button id={"break-cache-button"}
                    className={"header-button"}
                    onClick={breakCache}
                    data-tooltip={true} title="Break Cache"
                    data-position="left" data-alignment="center"
    >
        {loading && <><i className={`${faIcons.spinner} fa-spin`} data-testid={"spinner"}/><span>Loading</span></>}
        {!loading && <img className={"time-service-active-icon"} alt={"active"} src={iconHardReload}/>}
    </button>)
};
